import * as React from "react";

import { LOGIN_FORM_WINDOW_EVENTS } from "../../../Common";

import { usePdpWishlistUserExperience } from "./pdp-wishlist-user-experience-provider";

export const PdpWishlistUserExperienceTriggersProvider: React.FunctionComponent =
  (props) => {
    const {
      handlePdpAddToWishlistButtonClick_NotLoggedInUser,
      handlePdpAddToWishlistButtonClick_AlreadyLoggedInUser,
      handleLoginSuccess,
    } = usePdpWishlistUserExperience();

    React.useEffect(() => {
      window.addEventListener(
        `handle-pdp-add-to-wishlist-button-click-not-logged-in-user`,
        handlePdpAddToWishlistButtonClick_NotLoggedInUser
      );
      return () => {
        window.removeEventListener(
          "handle-pdp-add-to-wishlist-button-click-not-logged-in-user",
          handlePdpAddToWishlistButtonClick_NotLoggedInUser
        );
      };
    }, [handlePdpAddToWishlistButtonClick_NotLoggedInUser]);

    React.useEffect(() => {
      window.addEventListener(
        `handle-pdp-add-to-wishlist-button-click-already-logged-in-user`,
        handlePdpAddToWishlistButtonClick_AlreadyLoggedInUser
      );
      return () => {
        window.removeEventListener(
          `handle-pdp-add-to-wishlist-button-click-already-logged-in-user`,
          handlePdpAddToWishlistButtonClick_AlreadyLoggedInUser
        );
      };
    }, [handlePdpAddToWishlistButtonClick_AlreadyLoggedInUser]);

    React.useEffect(() => {
      window.addEventListener(
        LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
        handleLoginSuccess
      );
      return () => {
        window.removeEventListener(
          LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
          handleLoginSuccess
        );
      };
    }, [handleLoginSuccess]);

    return <React.Fragment>{props.children || []}</React.Fragment>;
  };
